// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root_KNyyz","badges":"Comment_badges_1Ir9g","controls":"Comment_controls_2UjKW","answer":"Comment_answer_1yz4p"};